export default __webpack_public_path__ + "static/media/addAccount.a78351b6.svg";